import ServiceDiscovery from './ServiceDiscovery';

export default ServiceDiscovery;
